import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  claimedInfo: {
    position: "absolute",
    left: 0,
    top: 22,
    color: "#e94448",
    letterSpacing: -0.5,
    lineHeight: "14px",
    padding: "0 2px"
  }
});
